import type { SVGProps } from 'react';

const IndentIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 23 23"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="none"
      {...props}
    >
      <path d="M11 1V12H22" stroke="currentColor" strokeLinecap="square" />
    </svg>
  );
};

export default IndentIcon;
